<template>
  <v-expansion-panels elevation="0">
    <v-expansion-panel class="flat-expansion-panel">
      <v-expansion-panel-title class="pl-0">
        <a class="learnMoreLink" href="#"><slot name="title"></slot></a>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <slot name="content"></slot>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
export default {
  name: 'AppFlatExpansionPanel',
}
</script>

<style scoped lang="scss">
@import "vuetify/settings";

.flat-expansion-panel {
  background-color: transparent !important;
  &:deep(.v-expansion-panel-title) {
    width: auto;
    min-height: $spacer * 6;
    padding: 0;
    margin: $spacer * 3 0;
  }
  &:deep(.v-expansion-panel-title__icon) {
    margin-left: $spacer * 2;
  }
  &:deep(.v-expansion-panel-title__icon .v-icon) {
    color: #4C75B5 !important;
    font-size: 14px;
    margin-bottom: $spacer;
  }
  &:deep(.v-expansion-panel-text__wrapper) {
    padding: 0;
  }
}
</style>
